'use strict';

function UserMessages() { }

UserMessages.getViewModel = function (element) {
    if (!element)
        element = $('.user-message-container');

    var vm = $(element).closest(".dynamic-form-placeholder, .modal").find('.hrm-page-messages-placeholder:first').parent().data('viewModel');

    if (!vm)
        throw new Error("Unable to retrieve view model for given user messages target.");

    return vm;
}

UserMessages.hideMessage = function (element) {
    UserMessages.getViewModel(element).clear();
};

UserMessages.HandleSuccessResultMessage = function (message) {
    var vm = UserMessages.getViewModel();
    vm.clear();
    vm.addMessage(message, 'info');
};

UserMessages.HandleErrorResultMessage = function (message) {
    var vm = UserMessages.getViewModel();
    vm.clear();
    vm.addMessage(message, 'error');
};

UserMessages.HandleWarningResultMessage = function (message) {
    var vm = UserMessages.getViewModel();
    vm.clear();
    vm.addMessage(message, 'warn');
};

UserMessages.ClearSuccessResultMessage = function () {
    var vm = UserMessages.getViewModel();
    vm.clear();
};

UserMessages.HandleFormErrorMessages = function (formElement, messages) {
    var vm = UserMessages.getViewModel(formElement);
    vm.clear();
    messages.forEach(function (message) {
        vm.addMessage(message, 'error');
    });
};
